module.exports = __webpack_public_path__ + "static/WEDDING E&M-519-4131a4862d4d3ebb9929a49f8ab88bcb.jpg";